import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'se-po-overview-card-docs',
  templateUrl: './overview-card-docs.component.html',
  styleUrls: ['./overview-card-docs.component.scss'],
  standalone: false,
})
export class OverviewCardDocsComponent implements OnInit {

  public form: FormGroup
  public personaId: string | number

  public ngOnInit(): void {
    this.form = new FormGroup({
      personaId: new FormControl()
    })
  }

  public updatePersonaId(): void {
    const personaId = Number(this.form.value.personaId)
    if (!Number.isInteger(personaId)) {
      return
    }
    this.personaId = personaId
  }

}
